import DashboardDispatcher from '../dispatcher/DashboardDispatcher'
import DashboardConstants from '../constants/DashboardConstants'


var DashboardActions = {

  init: function (opts) {
    DashboardDispatcher.dispatch({
      action: DashboardConstants.INIT,
      opts: opts
    });
  },

  gotoDate: function (date) {
    DashboardDispatcher.dispatch({
      action: DashboardConstants.GOTO_DATE,
      date: date
    });
  },

  refreshData: function () {
    DashboardDispatcher.dispatch({
      action: DashboardConstants.REFRESH_DATA,
    });
  },

  setActiveTab: function (activeTab) {
    DashboardDispatcher.dispatch({
      action: DashboardConstants.SET_ACTIVE_TAB,
      activeTab: activeTab
    });
  },

  onExpandCollapseRoomType: function (roomType, collapsed) {
    DashboardDispatcher.dispatch({
      action: DashboardConstants.EXPAND_COLLAPSE_ROOM_TYPE,
      collapsed: collapsed,
      roomType: roomType,
    });
  },

};

export default DashboardActions